import { Injectable, Provider } from '@angular/core';
import { QuestionSubmitReadyService } from '../../../question-v2/question-submit-ready';

@Injectable()
export class MultiAttemptQuestionSubmitReadyService extends QuestionSubmitReadyService {}

export function provideMultiAttemptQuestionSubmitReady(): Provider[] {
  return [
    MultiAttemptQuestionSubmitReadyService,
    { provide: QuestionSubmitReadyService, useExisting: MultiAttemptQuestionSubmitReadyService },
  ];
}
